import { createSlice } from "@reduxjs/toolkit";
import { ADD_DATA, ADD_DATA_MULTI, REMOVE_DATA_ARRAY_ITEM, REMOVE_DATA_KEY, RESET_DATA, RESET_DATA_KEY, SET_DATA, SET_DATA_MULTI } from 'services/redux/action-types'
import _ from 'lodash';
import { dataConstants } from "services/redux/data/constants";
import { CalendarViewModes } from 'utils/constants/calendar-modes-constants'

const initialState = {
	[ dataConstants.APP_IS_FOCUSED ]: true,
	[ dataConstants.APP_FULL_WIDTH ]: false,
	
	[ dataConstants.SERVER_TIMEZONE ]: 'Europe/Amsterdam',
	[ dataConstants.SERVER_TIMEZONE_OFFSET ]: 0,
	
	[ dataConstants.INITIAL_URL ]: null,
	[ dataConstants.APP_MESSAGES ]: {},
	[ dataConstants.SETTINGS ]: {},
	[ dataConstants.FILTERS ]: {},
	[ dataConstants.EMPLOYEE ]: {},
	[ dataConstants.BOOKINGS ]: {},
	[ dataConstants.BOOKINGS_PAST ]: {},
	[ dataConstants.LANGUAGES ]: {},
	//
	[ dataConstants.BUILDINGS ]: {},
	[ dataConstants.BUILDING_CAPACITIES ]: {},
	[ dataConstants.BUILDING_PARKING_SPACES ]: {},
	[ dataConstants.FLOORS ]: {},
	[ dataConstants.ROOMS ]: {},
	[ dataConstants.TABLES ]: {},
	[ dataConstants.DEPARTMENTS ]: {},
	[ dataConstants.TEAMS ]: {},
	
	[ dataConstants.TIMESLOT_KINDS ]: {},
	[ dataConstants.TIMESLOT_GROUPS ]: {},
	
	[ dataConstants.EMPLOYEES ]: {},
	
	[ dataConstants.EMPLOYEES_DETAILED ]: {},
	[ dataConstants.EMPLOYEES_BOOKINGS ]: {},
	
	[ dataConstants.EMPLOYEES_ERO ]: {},
	[ dataConstants.EMPLOYEES_ERO_LOADED ]: false,
	[ dataConstants.EMPLOYEES_CONFIDANTS ]: {},
	[ dataConstants.EMPLOYEES_CONFIDANTS_LOADED ]: false,
	
	//
	[ dataConstants.MEETING_ROOMS ]: {},
	
	[ dataConstants.FAVOURITES ] : {},
	[ dataConstants.BUILDING_FAVOURITES ] : {},
	[ dataConstants.FLOOR_FAVOURITES ] : {},
	[ dataConstants.ROOM_FAVOURITES ] : {},
	
	//
	[ dataConstants.PARKING_STATUSES ] : [],
	
	//
	[ dataConstants.INVITATIONS_SENT ]: {},
	[ dataConstants.INVITATIONS_SENT_COUNT ]: 0,
	//
	[ dataConstants.COWORKERS ]: [],
	[ dataConstants.EMPLOYEE_TRANSPORTS ]: {},
	[ dataConstants.TIMESLOTS_OCCUPIED ]: {},
	[ dataConstants.TIMESLOTS_OCCUPIED_MY_FAVOURITES ]: {},
	[ dataConstants.LUNCH_OPTIONS ]: {},
	
	// Notifications
	[ dataConstants.MESSAGES ]: {},
	[ dataConstants.MESSAGE_COUNT ]: 0,
	[ dataConstants.LINKS ]: {},
	
	// Calendar
	[ dataConstants.CALENDAR_VIEW_MODE_BOOKINGS ] : CalendarViewModes.WEEK,
	
	// Events
	[ dataConstants.EVENTS ]: {},
	
	// Others
	[ dataConstants.FETCHES ]: {},
	[ dataConstants.IN_MANAGEMENT ]: false,
	
	[ dataConstants.ALERT ]: null,
};

// Keep legacy action types and the flat data shape while consumers migrate.
const dataSlice = createSlice({
	name: 'data',
	initialState,
	reducers: {},
	extraReducers: ( builder ) => {
		builder
			.addCase( SET_DATA, ( state, action ) => {
				state[ action.key ] = action.payload;
			})
			.addCase( SET_DATA_MULTI, ( state, action ) => {
				Object.assign( state, action.payload );
			})
			.addCase( ADD_DATA, ( state, action ) => {
				if( _.isEmpty( action.payload ) ) {
					return;
				}

				// ADD_DATA replaces each supplied entry rather than merging it deeply.
				state[ action.key ] = {
					...state[ action.key ],
					...action.payload,
				};
			})
			.addCase( ADD_DATA_MULTI, ( state, action ) => {
				_.forEach( action.payload, ( values, key ) => {
					if( !_.isEmpty( values ) ) {
						state[ key ] = {
							...state[ key ],
							...values,
						};
					}
				});
			})
			.addCase( RESET_DATA_KEY, ( state, action ) => {
				state[ action.key ] = {
					...state[ action.key ],
					[ action.payload ]: action.value,
				};
			})
			.addCase( REMOVE_DATA_KEY, ( state, action ) => {
				if( state[ action.key ] ) {
					delete state[ action.key ][ action.payload ];
				}
			})
			.addCase( REMOVE_DATA_ARRAY_ITEM, ( state, action ) => {
				state[ action.key ] = _.without( state[ action.key ] ?? [], action.payload );
			})
			.addCase( RESET_DATA, () => {
				return initialState;
			});
	},
});

export default dataSlice.reducer;
